import React from "react";
import { xsollaProducts } from './../data/xsollaProducts';







export const ProductIcon = ({
  name,
  size = "md",
  width = 44,
  height = 44,
  color = 'white',
}) => {


  if (size === 'sm' && !width && !height) {
    width = 24;
    height = 24;
  }
  if (size === 'md' && !width && !height) {
    width = 36;
    height = 36;
  }
  if (size === 'md' && !width && !height) {
    width = 44;
    height = 44;
  }

  let icon = xsollaProducts[name] ? xsollaProducts[name]["icon"] : null;
  // if (!icon) return null;
  // icon = icon.replace(/\{52\}/g, `${width}`);
  // icon = icon.replace("0 0 52 52", `0 0 ${width} ${width}`);
  if (icon && color) icon = icon.replace("currentColor", color);
  var encoded = window.btoa(icon);

  if (xsollaProducts[name]) {return (
    <div
      style={{
        width: width,
        height: height,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        backgroundSize: '70%',
        backgroundImage: "url(data:image/svg+xml;base64,"+encoded+")"
      }}
      // dangerouslySetInnerHTML={{ __html: icon }}

    >
      {/* {name} */}
    </div>
  )} else {
    return null
  };
};
